import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { WhatYouLearn } from './components/WhatYouLearn';
import { ValueStack } from './components/ValueStack';
import { Pricing } from './components/Pricing';
import { UrgencyClose } from './components/UrgencyClose';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-bg font-sans selection:bg-brand-accent selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <WhatYouLearn data-id="element-3" />
      <ValueStack data-id="element-4" />
      <Pricing data-id="element-5" />
      <UrgencyClose data-id="element-6" />
      <Footer data-id="element-7" />
    </div>;
}